import { MTools } from '@/components';
import { IBooth } from '@/models/types/booth';
import { getBoothList } from '@/services/api';
import React, { useEffect, useRef, useState } from 'react';
import styles from './index.less';

interface ICompanyProps {

}


const step = 0.005;
const stepTime = 0.01;

const Company: React.FC<ICompanyProps> = (props) => {
  const [list, setList] = useState<IBooth[]>([]);
  // 当前滑动距离
  const [left, setLeft] = useState(0)
  const innerRef = useRef<any>()
  // timer
  const timerRef = useRef<any>()
  const touch = useRef<any>({})

  useEffect(() => {
    getListData()
  }, [])
  useEffect(() => {
    // 开启滑动
    timerRef.current = setTimeout(() => {
      next(left)
    }, 3000)
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])
  /**
   * 每次滑动
   *
   */
  const next = (current: number) => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      const nextCurrent = current + step
      if (current + step > 50) {
        innerRef.current.style.transition = `all 0s`;
        setLeft(0)
        setTimeout(() => {
          innerRef.current.style.transition = `all ${stepTime}s linear`;
          setLeft(step)
          next(step)
        }, 50)
      } else {
        setLeft(nextCurrent)
        next(nextCurrent)
      }
    }, stepTime * 1000)
  }

  const onTouchStart = (e: any) => {
    clearTimeout(timerRef.current)
    const width = '2526px'
    // window.getComputedStyle(innerRef.current).width
    if (!width) return
    touch.current.initiated = true;
    touch.current.lockTouchEnd = true
    touch.current.startX = e.touches[0].pageX;
    touch.current.width = +width.replace('px', '')
    touch.current.startLeft = left
    innerRef.current.style.transition = `all 0s`;
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd);
  }
  const onTouchMove = (e: any) => {
    const deltaX = e.touches[0].pageX - touch.current.startX;
    const width = touch.current.width
    let nextLeft = touch.current.startLeft + (-deltaX / width * 100)
    if (nextLeft > 50) {
      touch.current.startLeft = 0
      touch.current.startX = e.touches[0].pageX
    }
    nextLeft = nextLeft > 50 ? 0 : nextLeft < 0 ? 0 : nextLeft

    touch.current.currentLeft = nextLeft
    setLeft(nextLeft)
  }
  const onTouchEnd = () => {
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
    innerRef.current.style.transition = `all ${stepTime}s linear`; touch.current.initiated = false;
    next(touch.current.currentLeft)
  }

  const getListData = async () => {
    const result = await getBoothList()
    if (result.success) {
      if (result.data.length) {
        setList(result.data.filter((item: any) => item.showPosition === 1 || item.showPosition === 2))
      }
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  return (
    <div className={styles.companyList}>
      <div className={styles.list}>
        <div
          className={styles.listContent}
          onTouchStart={onTouchStart}
          ref={innerRef}
          style={{
            transform: `translateX(-${left}%)`,
            width: '2526px'
            // Math.ceil(list.length / 3) * 77 * 2
          }}
        >
          <img src="https://s.newscdn.cn/file/2022/08/97d38ac7-39c3-4d22-8b0d-c1b628a484d7.png" alt="" />

          <img src="https://s.newscdn.cn/file/2022/08/97d38ac7-39c3-4d22-8b0d-c1b628a484d7.png" alt="" />
          {/* <div className={styles.listInner}>
            {list.map((item, index) => {
              return <div
                key={index}
                className={styles.logo}
              >
                <div
                  className={styles.logoContent}
                  // style={{ backgroundImage: `url(${item.logo || item.cover})` }}
                  onClick={
                    () => {
                      if (item.showDetail === 1) {
                        MTools.Url.gotoUrl(`/app/company/${item.id}`)
                      }
                    }
                  }
                >
                  <img src={`${item.logo || item.cover}`}/>
                </div>
              </div>
            })}
          </div>
          <div className={styles.listInner}>
            {list.map((item, index) => {
              return <div
                key={index}
                className={styles.logo}
              >
                <div
                  className={styles.logoContent}
                  // style={{ backgroundImage: `url(${item.logo || item.cover})` }}
                  onClick={
                    () => {
                      if (item.showDetail === 1) {
                        MTools.Url.gotoUrl(`/app/company/${item.id}`)
                      }
                    }
                  }
                >
                  <img src={`${item.logo || item.cover}`}/>
                </div>
              </div>
            })}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Company;
